import { render } from "./IconFullScreen.vue?vue&type=template&id=4524cd98"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconFullScreen.vue"]])

export default __exports__